import { useEffect } from 'react'

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
const RecaptchaV3 = () => {
  useEffect(() => {
    const loadScript = () => {
      if (document.getElementById('recaptcha-script')) return

      const script = document.createElement('script')
      script.id = 'recaptcha-script'
      script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`
      script.async = true
      script.defer = true
      document.body.appendChild(script)
    }

    loadScript()
  }, [])

  return (
    <>
    <style jsx global>{`
      .grecaptcha-badge {
        visibility: visible;
      }
    `}</style>
    </>
  );
}

export default RecaptchaV3